import { connect } from 'react-redux';
import moment from 'moment';
import { getAvailableAddons } from '../redux/actions/dinings';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getAvailableArrivalTimeSlots, setArrivalPageWasBooked } from '../redux/actions/arrivalTime';
import { deleteEntertainment, saveAddon } from '../redux/actions/changeAddon';
import Schedule from '../components/schedule/Schedule';
import {
  compareEventsByStartTime,
  shouldFetch,
  shouldFetchDining,
  getShouldFetchAvailableEntertainments,
  breakfastType,
  dinnerType,
  getShouldSkipDiningPage,
  getIsArrivalTimeEditable,
  getArrivalStartTime,
  getArrivalEndTime,
  getIfAllowedToBook,
  getIfArrivalDateIsBeforeLatestArrivalSlotBookingDate,
} from '../utils';

const groupBy = (items, key) => items.reduce(
  (result, currentItem) => {
    const groupValue = currentItem[key];
    const newElement = result[groupValue] || [];
    return {
      ...result,
      [groupValue]: [...newElement, currentItem],
    };
  }, {},
);

const getDailyEvents = (events, arrivalDateString, departureDateString) => {
  const groupedEvents = groupBy(events, 'startDate');
  const departureDate = moment(departureDateString, 'YYYY-MM-DD');
  const dailyEvents = {};
  let iteratorDate = moment(arrivalDateString, 'YYYY-MM-DD');
  for (iteratorDate; iteratorDate.isSameOrBefore(departureDate, 'day'); iteratorDate = iteratorDate.add(1, 'day')) {
    dailyEvents[iteratorDate.format('YYYY-MM-DD')] = [];
  }
  const dates = Object.keys(dailyEvents);
  dates.forEach((date) => {
    if (!!groupedEvents[date] && groupedEvents[date].length > 0) {
      const currentEvents = [...groupedEvents[date]];
      currentEvents.sort(compareEventsByStartTime);
      dailyEvents[date] = currentEvents;
    }
  });

  return dailyEvents;
};

const getShowEmptyDiningCard = (dinings, bookingSearch, diningType, config) => {
  const { bookedBreakfast, bookedDinner } = dinings;
  const bookedDining = diningType === breakfastType ? bookedBreakfast : bookedDinner;
  const hasBookedDining = !!bookedDining && bookedDining.AddonCategory === diningType;
  const diningWasSkipped = getShouldSkipDiningPage(dinings, bookingSearch, diningType, config);
  return !diningWasSkipped && !hasBookedDining;
};

const getShowEmptyArrivalCard = (
  { bookedArrivalSlotId, arrivalTimeSlots },
  isArrivalTimeEditable,
  isArrivalDateBeforeLatestArrivalSlotBookingDate,
) => !bookedArrivalSlotId && isArrivalTimeEditable && arrivalTimeSlots.length > 0 && isArrivalDateBeforeLatestArrivalSlotBookingDate;

const mapStateToProps = ({
  dinings,
  availableEntertainments,
  bookingSearch,
  bookedEvents,
  bookedEntertainments,
  config,
  arrivalTime,
}) => {
  const { isAllowedToBookEntertainment, isAllowedToBookSwimming } = getIfAllowedToBook(bookingSearch, config);
  const showEmptyArrival = getShowEmptyArrivalCard(
    arrivalTime,
    getIsArrivalTimeEditable(config, bookingSearch),
    getIfArrivalDateIsBeforeLatestArrivalSlotBookingDate(bookingSearch, config),
  );
  const arrivalStartTime = getArrivalStartTime(arrivalTime);
  const arrivalEndTime = getArrivalEndTime(arrivalTime);
  const showAppLinksMessage = !isAllowedToBookEntertainment || !isAllowedToBookSwimming;

  return {
    dailyEvents: getDailyEvents(bookedEvents.eventsWithPastEvents, bookingSearch.arrivalDate, bookingSearch.departureDate),
    hasPastEvents: bookedEvents.eventsWithPastEvents.length > bookedEvents.events.length,
    resId: bookingSearch.resId,
    siteCode: bookingSearch.siteCode,
    shouldFetchAvailableAddons: shouldFetchDining(dinings, bookingSearch, config),
    shouldFetchAvailableEntertainments: getShouldFetchAvailableEntertainments(availableEntertainments, bookedEntertainments, bookingSearch, config),
    shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
    availableEntertainments: availableEntertainments.entertainments,
    splashEntertainments: availableEntertainments.splashEntertainments,
    showEmptyBreakfast: getShowEmptyDiningCard(dinings, bookingSearch, breakfastType, config),
    showEmptyDinner: getShowEmptyDiningCard(dinings, bookingSearch, dinnerType, config),
    showEmptyArrival,
    shouldFetchAvailableArrivalTimeSlots: shouldFetch(arrivalTime, bookingSearch, config),
    arrivalStartTime,
    arrivalEndTime,
    isArrivalTimeEditable: getIsArrivalTimeEditable(config, bookingSearch),
    playStoreLink: config[`REACT_APP_PLAY_STORE_${bookingSearch.siteCode.toUpperCase()}`],
    appStoreLink: config[`REACT_APP_APP_STORE_${bookingSearch.siteCode.toUpperCase()}`],
    resortMessage: config[`REACT_APP_REPLACED_BY_APP_${bookingSearch.siteCode.toUpperCase()}`],
    showAppLinksMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  getAvailableAddons: resId => dispatch(getAvailableAddons(resId)),
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  getAvailableArrivalTimeSlots: () => dispatch(getAvailableArrivalTimeSlots()),
  deleteEntertainment: (resId, siteCode, timeSlotId, eventDate, startTime, endTime, name) => dispatch(
    deleteEntertainment(resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, true),
  ),
  removeDining: (resId, addonCode) => dispatch(saveAddon(resId, addonCode, 'cancel', true)),
  setArrivalPageWasBooked: wasBooked => dispatch(setArrivalPageWasBooked(wasBooked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
